import { type FC } from 'react';
import clsx from 'clsx';

import { useSizeStore } from 'store/size';
import { useTimerStore } from 'store/timer';

import logo from 'static/images/logo.svg';

import styles from './styles.module.scss';
import Timer from './Timer';

const Top: FC = () => {
    const { isFull } = useSizeStore();
    const { availableTime } = useTimerStore();

    return (
        <div className={clsx(styles.wrapper, { [styles.wrapperIsFull]: isFull })}>
            <img src={logo} alt='Тренд Новостройки' />
            {availableTime && <Timer />}
        </div>
    );
};

export default Top;
